module.exports = {
      id: "cadastrar-paypal-usage",
      viewBox: "0 0 163 117",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#cadastrar-paypal",
      toString: function () {
        return this.url;
      }
    }